import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import GradingFeedback from 'components/DemonstrationViewer/Submission/PreviousResponse/GradingFeedback';
import DateFormat from 'constants/date_format';
import AttemptStatus from './AttemptStatus';

const formatDate = date => moment(date).format(DateFormat.MONTH_DAY_SHORT);

const PreviousResponse = ({ submission, status, grade, completedAt }) => {
  return (
    <li className="d-f fd-c mb-32">
      <div className="Card ContentItem--list d-f py-16  pl-16 pr-32 m-fd-rc">
        <a
          className="f-1 m-fb-auto pr-32 c-brand-blue text-wrap"
          href={submission.url}
        >
          {submission.url}
        </a>
        <span className="f-3 m-fb-auto f-d fd-c">
          <AttemptStatus status={status} grade={grade} />
          <span className="d-f fd-r mt-8">{formatDate(completedAt)}</span>
        </span>
      </div>
      {grade && <GradingFeedback grade={grade} />}
    </li>
  );
};

PreviousResponse.propTypes = {
  submission: PropTypes.shape({
    url: PropTypes.string,
  }),
  grade: PropTypes.shape({
    success: PropTypes.bool,
  }),
  status: PropTypes.string,
  completedAt: PropTypes.string,
};

export default PreviousResponse;
